<template>
  <div>
    <p>Inventory content here.</p>
  </div>
</template>

<style scoped>

</style>

<script>
import Inventory from "./inventory.ts";
export default Inventory;
</script>